<div class="er-links-container" [ngClass]="{'router-loading': isLoading}">
  <div class="er-links-buttons">
    @if (showRegistrationKey) {
      <div (click)="copyToken()" class="download-button">
        <div class="download-key"></div>
        <div>COPY REGISTRATION KEY</div>
        <div class="tap-to-copy"></div>
      </div>
    }
    @if (hasJwt && !enrollmentExpired) {
      <div (click)="svc.downloadJWT()" class="download-button">
        <div class="download-jwt"></div>
        <div>DOWNLOAD ENROLLMENT JWT</div>
        <div class="tap-to-download"></div>
      </div>
    }
    @if (showReissueJWT) {
      <div (click)="reissueEnrollmentJWT()" class="download-button" >
        <div class="refresh-jwt icon-refresh"></div>
        <div>REISSUE ENROLLMENT JWT</div>
        <div class="tap-to-download"></div>
      </div>
    }
    @if (showReEnroll) {
      <div (click)="reEnrollRouter()" class="download-button">
        <div class="download-key"></div>
        <div>Re-Enroll Router</div>
        <div class="tap-to-download"></div>
      </div>
    }
    <!--<div (click)="downloadConfig()" class="download-button download-config">
    <div class="download-icon router-icon"></div>
    <div>DOWNLOAD CONFIG</div>
    <div class="download-icon config-icon"></div>
  </div>-->
  <div (click)="getVMs()" class="download-button download-vm" >
    <div class="download-key vm-icon"></div>
    <div>GET THE VM</div>
    <div class="vm-download"></div>
  </div>
  @if (enrollmentExpired) {
    <span class="info-text">ENROLLMENT JWT EXPIRED {{expirationDate}}</span>
  }
</div>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
